import OfferCard from './OfferCard'

export default {
  name: 'OfferList',
  components: { OfferCard },
  template: `
    <div class="offer-list grid">
      <div v-for="offer in offers" class="col-12 col-sm-6 col-lg-4" :key="offer.slug">
        <OfferCard :offer="offer" :key="offer.offerId" />
      </div>
    </div>
  `,
  props: { offers: Array },
}
